module.exports = __webpack_public_path__ + "img/banner4.349be6be.png";